<template>
  <div>
    <el-row style="">
      <el-input class="search-el" size="mini" v-model="query.title" placeholder="请输入标题"></el-input>
      <el-button type="primary" size="mini" @click="getList()">查询</el-button>
      <el-button type="primary" size="mini" @click="dialogFormVisible = true">创建模板</el-button>
    </el-row>
    <el-row >
      <el-table :data="listData" style="width: 100%" border size="mini" v-loading="listLoading">
        <el-table-column prop="id" label="模板ID" width="100"></el-table-column>
        <el-table-column prop="title" label="模板标题" width="200"></el-table-column>
        <el-table-column prop="template_id" label="模板CODE" width="120" ></el-table-column>
        <el-table-column prop="content" label="模板内容" width="400"></el-table-column>
        <el-table-column label="模板变量" width="220">
          <template slot-scope="{ row }">
            <el-tag size="small" v-for="title in row.var_type_title" :key="title">{{ title }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="审核状态" width="80">
          <template slot-scope="{ row }">{{ row.status == 1 ? '已通过' : '审核中' }}</template>
        </el-table-column>
        <el-table-column prop="created_at" label="创建时间" width="140"></el-table-column>
        <el-table-column label="操作" width="220">
          <template slot-scope="{ row }">
            <template v-if="row.status == 0">
              <el-button size="mini" type="primary" @click="onlineVoiceTemplate(row.id)">审核通过</el-button>
            </template>
            <el-button type="danger" icon="el-icon-delete" size="mini" @click="deleteTemplate(row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div style="margin-top:10px">
        <el-pagination background @current-change="getList(0)" :current-page.sync="query.page"
                       :page-size="query.limit"
                       layout="total, prev, pager, next, jumper" :total="listTotal">
        </el-pagination>
      </div>
    </el-row>

    <el-dialog title="创建模板" :visible.sync="dialogFormVisible">
      <el-form :model="form" label-width="100px">
        <el-form-item label="标题" >
          <el-input v-model="form.title" ></el-input>
        </el-form-item>
        <el-form-item label="模板CODE" >
          <el-input v-model="form.template_id" ></el-input>
        </el-form-item>
        <el-form-item label="模板内容" >
          <el-input type="textarea" v-model="form.content" ></el-input>
        </el-form-item>
        <el-form-item label="模板包含变量">
          <el-checkbox label="用户名称" v-model="form.user_name"></el-checkbox>
          <el-checkbox label="课程名称" v-model="form.course_name"></el-checkbox>
          <el-checkbox label="渠道名称" v-model="form.source_name"></el-checkbox>
          <el-checkbox label="开课时间" v-model="form.time_str"></el-checkbox>
          <el-checkbox label="老师姓名" v-model="form.teacher_name"></el-checkbox>
        </el-form-item>
        <el-form-item label="变量规则" >
          <template v-if="form.user_name == true">用户名称”${user}“、</template>
          <template v-if="form.course_name == true">课程名称”${course}“、</template>
          <template v-if="form.source_name == true">渠道名称”${source}“、</template>
          <template v-if="form.time_str == true">开课时间”${time}“</template>
          <template v-if="form.teacher_name == true">老师姓名”${teacher}“</template>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="createVoiceTemplate()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {getList, createVoiceTemplate,
  deleteVoiceTemplate,
  onlineVoiceTemplate} from "@/api/voice";

export default {
  data:function () {
    return {
      id: '',
      listData:[],
      listLoading:false,
      listTotal: 0,
      dialogFormVisible:false,
      form:{
        title: '',
        template_id: '',
        content: '',
        user_name: false,
        course_name: false,
        source_name: false,
        time_str: false,
        teacher_name: false,
      },
      query:{
        title:'',
        limit: 10,
        page: 1
      }
    }
  },
  created: function() {
    this.getList();
  },
  methods: {
    getList(){
      this.listLoading = true;
      getList(this.query).then(response => {
        this.listData = response.data.list
        this.listTotal = response.data.total
        this.listLoading = false;
      });
    },
    createVoiceTemplate(){
      createVoiceTemplate(this.form).then(res => {
        if(res.status == 2000){
          this.form = {
            title: '',
            template_id: '',
            content: '',
            user_name: false,
            course_name: false,
            source_name: false,
            time_str: false,
          }
          this.dialogFormVisible = false;
          this.getList();
          this.$message({
            showClose: true,
            message: "创建成功",
            type: "success",
          });
        }
      });
    },
    onlineVoiceTemplate(id){
      onlineVoiceTemplate({id}).then(() => {
        this.getList();
      });
    },
    deleteTemplate(id) {
      this.$confirm("确定执行删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        deleteVoiceTemplate({
          id: id,
        }).then((response) => {
          if (response.status == 2000) {
            this.getList();
            this.$message({
              showClose: true,
              message: "删除成功",
              type: "success",
            });
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error",
            });
          }
        });
      });
    },
  },
}
</script>
<style>
.el-button{
  margin-left: 10px;
  margin-bottom: 10px;
}
</style>